/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Like: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M12.8624 5.43947C15.0111 3.45632 18.3361 3.52237 20.4064 5.63771L20.5988 5.84474C22.4671 7.95668 22.4669 11.1731 20.5988 13.2852L20.4064 13.4932L20.3751 13.5235L12.6837 20.7295C12.2991 21.0899 11.7011 21.0899 11.3165 20.7295L3.62514 13.5235L3.59389 13.4932C1.46867 11.3217 1.46874 7.80925 3.59389 5.63771L3.79799 5.43947C5.94663 3.45618 9.27163 3.52236 11.3419 5.63771L12.0001 6.30958L12.6583 5.63771L12.8624 5.43947ZM9.91225 7.03615C8.60181 5.69763 6.51146 5.65594 5.15248 6.91115L5.02358 7.03615C3.66191 8.42747 3.65956 10.6902 5.01576 12.085L12.0001 18.6299L18.9835 12.085C20.2977 10.7339 20.3374 8.56907 19.1007 7.16993L18.9767 7.03615C17.6663 5.69754 15.576 5.65605 14.2169 6.91115L14.088 7.03615L12.715 8.43947C12.5269 8.63166 12.2691 8.74025 12.0001 8.74025C11.7312 8.74025 11.4734 8.63166 11.2853 8.43947L9.91225 7.03615Z'
      fill='currentColor'
    />
  </React.Fragment>
)
